import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "email-verification"
    }}>{`Email Verification`}</h1>
    <p>{`We implement the `}<inlineCode parentName="p">{`Email Verification`}</inlineCode>{` feature on PickBazar `}<inlineCode parentName="p">{`v8.2.0`}</inlineCode>{`. So if you want to use `}<inlineCode parentName="p">{`Email Verification`}</inlineCode>{` with `}<inlineCode parentName="p">{`PickBazar,`}</inlineCode>{` then make sure your PickBazar is `}<inlineCode parentName="p">{`v8.2.0`}</inlineCode>{` or later.`}</p>
    <p>{`With the Email Verification feature, you can do,`}</p>
    <pre><code parentName="pre" {...{}}>{`- Get Email After Registration
- Email verification for updating Email in profile update section
- When Email verification is on in settings then users will be forced to verify their email.
`}</code></pre>
    <h2 {...{
      "id": "how-to-turn-on-this-feature"
    }}>{`How to turn on this feature`}</h2>
    <p>{`To turn on this feature go to settings of your site then find `}<inlineCode parentName="p">{`Enable Must Verify Email`}</inlineCode>{` switch.`}</p>
    <p><img alt="enable-email-verify-switch.png" src={require("./images/enable-email-verify-switch.png")} /></p>
    <h2 {...{
      "id": "admin-view-of-this-feature"
    }}>{`Admin view of this feature`}</h2>
    <p><img alt="verify-email-admin-view.png" src={require("./images/verify-email-admin-view.png")} /></p>
    <h2 {...{
      "id": "shop-view-of-this-feature"
    }}>{`Shop view of this feature`}</h2>
    <p><img alt="verify-email-shop-view.png" src={require("./images/verify-email-shop-view.png")} /></p>
    <h2 {...{
      "id": "configuration"
    }}>{`Configuration`}</h2>
    <p>{`To use this feature all you need to configure mail in your application.`}</p>
    <pre><code parentName="pre" {...{}}>{`MAIL_MAILER=mailgun
MAILGUN_DOMAIN=
MAILGUN_SECRET=
MAIL_FROM_ADDRESS=
MAIL_PORT=1025
MAIL_USERNAME=null
MAIL_PASSWORD=null
MAIL_ENCRYPTION=null
ADMIN_EMAIL=support@example.com
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      